export default "__VITE_ASSET__yiszfL$p__"